import { cva } from 'class-variance-authority';

var clazz = cva("bg-white", {
    variants: {
        hover: {
            true: "group/body",
        }
    },
    defaultVariants: {}
});

export { clazz };
